export const removeAllWhitespaces = (str: string): string => {
    return str.replace(/\s+/g, '');
  };